import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import CommonProps from './common/common-props';
import Desktop from './banner-components/desktop';
import Mobile from './banner-components/mobile';
import Tablet from './banner-components/tablet';

export default function Banner({ banner }) {
  const commonProps = CommonProps();
  const { isTablet, isMobileOrTablet } = commonProps;
  /* eslint-disable no-nested-ternary */
  const BannerToShow = !isMobileOrTablet ? Desktop : isTablet ? Tablet : Mobile;
  /* eslint-enable no-nested-ternary */

  return (
    <ThemeProvider theme={commonProps}>
      <BannerToShow
        banner={banner}
        signUpUrl="/sign_up?utm_medium=banner&intent=sign_up"
        signInUrl="/sign_in?utm_medium=banner&intent=sign_in"
      />
    </ThemeProvider>
  );
}

Banner.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string.isRequired,
    byline: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    registerButtonCopy: PropTypes.string,
  }).isRequired,
};
